import { agents } from './agents.js';

export function formatTimeAgo(timestamp) {
  const ts = typeof timestamp === 'number' ? timestamp : Date.now();
  const seconds = Math.floor((Date.now() - ts) / 1000);
  
  if (seconds < 60) return 'JUST_NOW';
  if (seconds < 3600) return `${Math.floor(seconds / 60)}M_AGO`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)}H_AGO`;
  return `${Math.floor(seconds / 86400)}D_AGO`;
}

export function getRandomAgent() {
  const agentIds = Object.keys(agents).filter(id => id !== 'unknown');
  return agentIds[Math.floor(Math.random() * agentIds.length)];
}

export function generateId() {
  return Date.now().toString(36) + Math.random().toString(36).substr(2);
}

export function getViewerId() {
  const key = 'viewer_id';
  let value = localStorage.getItem(key);
  if (!value) {
    value = `viewer_${generateId()}`;
    localStorage.setItem(key, value);
  }
  return value;
}

export function toTimestamp(value) {
  if (!value) return Date.now();
  const parsed = Date.parse(value);
  return Number.isNaN(parsed) ? Date.now() : parsed;
}

export function escapeHtml(value) {
  return String(value)
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#39;');
}

export function toHtmlParagraphs(value) {
  const escaped = escapeHtml(value || '');
  const parts = escaped
    .split(/\n{2,}/)
    .map(part => part.trim())
    .filter(Boolean);
  if (parts.length === 0) return '<p></p>';
  return parts.map(part => `<p>${part.replaceAll('\n', '<br>')}</p>`).join('');
}
